"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchData = exports.ADVERT_SEARCH_TAB_POSITIONS = void 0;
exports.ADVERT_SEARCH_TAB_POSITIONS = [
    { id: "all", name: "Tous", position: 1, checked: false },
    { id: "rcps", name: "Medics", position: 1, checked: false },
    { id: "tools", name: "Tools", position: 1, checked: false },
    { id: "drive", name: "Drive", position: 1, checked: false },
    { id: "prescription", name: "E-Prescription", position: 1, checked: false },
    { id: "news", name: "Actualités", position: 1, checked: false },
    { id: "articles", name: "Articles", position: 1, checked: false },
];
class SearchData {
    constructor(data) {
        this.position = 0;
        this.tabs = [];
        this.tabPositions = [];
        this.association = null;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.position = parseInt(data.position);
            this.tabs = data.tabs;
            this.tabPositions = (typeof data.tabPositions === "undefined") ? exports.ADVERT_SEARCH_TAB_POSITIONS : data.tabPositions;
            this.association = data.association || null;
        }
    }
}
exports.SearchData = SearchData;
//# sourceMappingURL=SearchData.js.map